<template>
  <div v-if="cdata.length" class="left-top">
    <v-chart :forceFit="true" :height="height" :data="cdata" :padding="padding">
      <!-- <v-coord type="rect" direction="LT" />
      <v-tooltip />
      <v-legend />
      <v-axis dataKey="count" position="right" :label="label2" />
      <v-axis dataKey="item" :label="label" />
      <v-bar position="item*count" /> -->
			<v-coord type="rect" direction="LT" />
			<v-legend />
			<v-tooltip />
			<v-axis dataKey="item" :label="label" />
			<v-axis dataKey="count"  :label="label2" />
			<v-bar position="item*count" />
    </v-chart>
  </div>
</template>

<script>
const DataSet = require('@antv/data-set')

export default {
  props: {
    advice: {
      default() {
        return []
      },
    },
  },
  mounted() {
    const data = this.advice
		this.advice.forEach(item => {
			item.count = Number(item.count)
		})
		console.log('----1', data)
    const dv = new DataSet.View().source(data)
    dv.transform({
      type: 'sort',
      callback(a, b) {
        return a.count - b.count > 0
      },
    })
    const cdata = dv.rows

    const scale = [
      {
        dataKey: 'count',
        tickInterval: 20,
      },
    ]

    const label = {
      offset: 12,
      textStyle: {
        fill: '#82A9EF',
      },
    }
    const label2 = {
      textStyle: {
        fill: '#82A9EF',
      },
    }
    const adjust = [{ type: 'dodge', marginRatio: 1 / 32 }]
    this.adjust = adjust
    this.scale = scale
    this.label = label
    this.label2 = label2
    this.cdata = cdata
  },
  data() {
    return {
      scale: [],
      cdata: [],
      height: 430 * (window.innerWidth / 1920),
      label: [],
      label2: [],
      adjust: [],
      padding: [
        10 * (window.innerWidth / 1920),
        20 * (window.innerWidth / 1920),
        120 * (window.innerWidth / 1920),
        125 * (window.innerWidth / 1920),
      ],
    }
  },
}
</script>

<style lang="less" scoped>
.left-top {
  padding: 0 15px;
  margin-top: 36px;
}
</style>
